import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=b49c239e&scoped=true&"
import script from "./Information.vue?vue&type=script&lang=js&"
export * from "./Information.vue?vue&type=script&lang=js&"
import style0 from "./Information.vue?vue&type=style&index=0&id=b49c239e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49c239e",
  null
  
)

export default component.exports